import React, { useState, useContext, useEffect } from "react";
import axios from "../../helper/axios";
import { AuthContext } from "../../context/AuthContext";
import "./AddProducts.css";
import "./DashboardMain.css";
import { useLocation } from "react-router-dom";

const UpdateProduct = () => {
  const [products, setProducts] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const { token } = useContext(AuthContext);
  const location = useLocation();

  const [getShape, setShape] = useState([]);
  const [getCut, setCut] = useState([]);
  const [getColor, setColor] = useState([]);
  const [getClarity, setClarity] = useState([]);

  const [dataFetched, setDataFetched] = useState(false);
  // Add separate state variables to track the selected values
  const [selectedShape, setSelectedShape] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedCut, setSelectedCut] = useState("");
  const [selectedClarity, setSelectedClarity] = useState("");

  const [isProductUpdated, setIsProductUpdated] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Determine the active class based on the current route
  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  useEffect(() => {
    fetchDiamondData();
    fetchProducts();
  }, [currentPage]);

  useEffect(() => {}, [products, isProductUpdated]);

  const fetchProducts = async () => {
    const allData = {
      category: ["diamond"],
      pageNo: currentPage,
    };
    try {
      const response = await axios.post(`/product_read`, allData);
      const sortedProducts = response.data.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setProducts(sortedProducts);
    } catch (error) {
      console.error(error.response.data);
      // alert('Failed to fetch products.');
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const fetchDiamondData = async () => {
    const allData = {
      category: ["diamond"],
    };
    try {
      const response = await axios.post(`/product_read`, allData);
      setProducts(response.data.data);

      const shapeData = await axios.get("/shape_read");
      const shapeProduct = shapeData.data.data;
      setShape(shapeProduct);

      const colorData = await axios.get("/color_read");
      const colorProduct = colorData.data.data;
      setColor(colorProduct);

      const clarityData = await axios.get("/clarity_read");
      const clarityProduct = clarityData.data.data;
      setClarity(clarityProduct);

      const cutData = await axios.get("/cut_read");
      const cutProduct = cutData.data.data;
      setCut(cutProduct);

      // Set the dataFetched flag to true once all data is fetched successfully
      setDataFetched(true);
    } catch (error) {
      console.error(error.response.data);
      // alert('Failed to fetch products.');
    }
  };

  const ListColor =
    getColor.length > 0 ? (
      getColor.map((color) => (
        <option key={color.color_id} value={color.color_id}>
          {color.color_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListShape =
    getShape.length > 0 ? (
      getShape.map((shape) => (
        <option key={shape.shape_id} value={shape.shape_id}>
          {shape.shape_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListCut =
    getCut.length > 0 ? (
      getCut.map((cut) => (
        <option key={cut.cut_id} value={cut.cut_id}>
          {cut.cut_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListClarity =
    getClarity.length > 0 ? (
      getClarity.map((clarity) => (
        <option key={clarity.clarity_id} value={clarity.clarity_id}>
          {clarity.clarity_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const openEditModal = (productId) => {
    const product = products.find(
      (product) => product.product_id === productId
    );
    if (product) {
      setEditingProduct({ ...product });
      setModalOpen(true);
    } else {
      console.log("Product not found");
    }
  };

  const closeEditModal = () => {
    setEditingProduct(null);
    setModalOpen(false);
  };

  const handleSaveClick = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formData = new FormData();

      formData.append("color_id_fk", selectedColor);
      formData.append("shape_id_fk", selectedShape);
      formData.append("clarity_id_fk", selectedClarity);
      formData.append("cut_id_fk", selectedCut);
      formData.append("carat", editingProduct.carat);
      formData.append("price", editingProduct.product_price);
      formData.append("product_sku", editingProduct.product_sku);
      formData.append("product_image", editingProduct.product_image);
      formData.append("category_id_fk", "5");
      formData.append("product_name", "diamond");
      formData.append("stone_type", "diamond");
      formData.append("matching_band", "0");
      formData.append("in_stock", 1);
      formData.append("metal_id_fk", "11");
      formData.append("product_type_id_fk", "9");
      formData.append("settings_id_fk", "9");
      formData.append("style_id_fk", "14");

      const response = await axios.put(
        `/product_update/${editingProduct.product_id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.product_id === editingProduct.product_id
            ? { ...product, ...formData }
            : product
        )
      );
      // alert('Product Updated Successfully!', response.data);

      setModalOpen(false);
      setIsProductUpdated(true);

      fetchProducts();
    } catch (error) {
      console.error(error.response.data);
      alert("Update Failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const deleteProduct = async () => {
    // Check if any products are selected
    if (selectedProducts.length === 0) {
      alert("Please select products to delete.");
      return;
    }

    if (
      window.confirm("Are you sure you want to delete the selected products?")
    ) {
      setIsDeleting(true);
      try {
        const promises = selectedProducts.map((productId) =>
          axios.delete(`/product_delete/${productId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
        );

        await Promise.all(promises);

        setProducts((prevProducts) =>
          prevProducts.filter(
            (product) => !selectedProducts.includes(product.product_id)
          )
        );

        setSelectedProducts([]);
        alert("Selected Products Deleted Successfully!");

        fetchProducts();
      } catch (error) {
        console.error(error.response.data);
        alert("Failed to delete products.");
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const handleCheckboxChange = (productId) => {
    if (selectedProducts.includes(productId)) {
      setSelectedProducts(selectedProducts.filter((id) => id !== productId));
    } else {
      setSelectedProducts([...selectedProducts, productId]);
    }
  };

  return (
    <>
      {dataFetched ? ( // Show the table only when the data is fetched
        <div className="">
          {/* <h3>Update Products</h3> */}

          <h5 className="mt-4 mb-3">{products.length} products available</h5>

          {products.length > 0 ? (
            <>
              <table className="product-table table">
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>Image</th>
                    <th>SKU</th>
                    <th>Shape</th>
                    <th>Carat</th>
                    <th>Color</th>
                    <th>Cut</th>
                    <th>Clarity</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((product, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedProducts.includes(
                            product.product_id
                          )}
                          onChange={() =>
                            handleCheckboxChange(product.product_id)
                          }
                        />
                      </td>
                      <td>
                        <img
                          src={product.product_image}
                          alt="Product img"
                          className="product-table-img"
                        />
                      </td>
                      <td>{product.product_sku}</td>
                      <td>{product.shape_name}</td>
                      <td>{product.carat}</td>
                      <td>{product.color_name}</td>
                      <td>{product.cut_name}</td>
                      <td>{product.clarity_name}</td>
                      <td>{product.product_price}</td>
                      <td>
                        <span
                          className="action-icon edit-product"
                          onClick={() => openEditModal(product.product_id)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </span>
                        <span
                          className="action-icon delete-products"
                          onClick={() => deleteProduct(product.product_id)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="pagination mx-auto">
                <button
                  className="btn btn__primary"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <p className="page-number mx-2">{currentPage}</p>
                <button
                  className="btn btn__primary"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <p>No products available</p>
          )}
        </div>
      ) : (
        <p>Loading data...</p> // Show a loading message while the data is being fetched
      )}

      {modalOpen && editingProduct && (
        <div
          className="modal fade show product-modal"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Edit {editingProduct.shape} Shaped Diamond
                </h5>
                <button
                  type="button"
                  className="close btn"
                  onClick={closeEditModal}
                  data-bs-dismiss="modal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSaveClick} className="py-3 m-0">
                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Select Shape
                      </label>
                      {selectedShape}
                      <select
                        className="form-select"
                        aria-label="Shape"
                        value={selectedShape}
                        onChange={(e) => (
                          setSelectedShape(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            shape: e.target.value,
                          })
                        )}
                      >
                        {ListShape}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Select Color
                      </label>
                      <select
                        className="form-select"
                        aria-label="Color"
                        value={selectedColor}
                        onChange={(e) => (
                          setSelectedColor(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            color: e.target.value,
                          })
                        )}
                      >
                        {ListColor}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Select Cut
                      </label>
                      <select
                        className="form-select"
                        aria-label="Cut"
                        value={selectedCut}
                        onChange={(e) => (
                          setSelectedCut(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            cut: e.target.value,
                          })
                        )}
                      >
                        {ListCut}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Select Clarity
                      </label>
                      <select
                        className="form-select"
                        aria-label="Clarity"
                        value={selectedClarity}
                        // onChange={(e) => setSelectedClarity(e.target.value)}
                        onChange={(e) => (
                          setSelectedClarity(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            clarity: e.target.value,
                          })
                        )}
                      >
                        {ListClarity}
                      </select>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Carat
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="carat"
                        value={editingProduct.carat}
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            carat: e.target.value,
                          })
                        }
                        id=""
                        placeholder="Enter Carat"
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Price
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="product_price"
                        value={editingProduct.product_price}
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            product_price: e.target.value,
                          })
                        }
                        id=""
                        placeholder="Enter Price"
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Products SKU
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="product_sku"
                        disabled
                        value={editingProduct.product_sku}
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            product_sku: e.target.value,
                          })
                        }
                        id=""
                        placeholder="Enter Diamond SKU"
                      />
                      {/* {skuError && <div className="mt-2 alert alert-danger">{skuError}</div>} */}
                    </div>

                    <div className="col-sm-12 my-4">
                      <label htmlFor="" className="form-label">
                        Products Images
                      </label>
                      <input
                        className="form-control m-0"
                        name="product_image"
                        accept="image/*"
                        type="file"
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            product_image: e.target.files[0],
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="submit"
                      className="btn btn__primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save"}
                    </button>
                    <button
                      type="button"
                      className="btn btn__primary"
                      onClick={closeEditModal}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateProduct;
